import queryClient from '~src/config/queryClient';
import { QUERY_KEYS } from '~src/hooks/api/constants';
import { AdminFeedbackCycle, AdminFeedbackCycleResponse } from './types';

const feedbackCycleCache = {
  addFeedbackCycle: (newCycle: AdminFeedbackCycle) => {
    const cachedFeedbackCycles = queryClient.getQueryData<AdminFeedbackCycleResponse>([
      QUERY_KEYS.ADMIN_FEEDBACK_CYCLES,
    ]);

    if (cachedFeedbackCycles) {
      queryClient.setQueryData([QUERY_KEYS.ADMIN_FEEDBACK_CYCLES], {
        ...cachedFeedbackCycles,
        items: [newCycle, ...cachedFeedbackCycles.items],
      });
    }
  },
  deleteFeedbackCycle: (cycleId: string) => {
    const cachedFeedbackCycles = queryClient.getQueryData<AdminFeedbackCycleResponse>([
      QUERY_KEYS.ADMIN_FEEDBACK_CYCLES,
    ]);

    if (cachedFeedbackCycles) {
      queryClient.setQueryData([QUERY_KEYS.ADMIN_FEEDBACK_CYCLES], {
        ...cachedFeedbackCycles,
        items: cachedFeedbackCycles.items.filter((item) => item.id !== cycleId),
      });
    }
  },
  updateFeedbackCycle: (cycle: AdminFeedbackCycle) => {
    const cachedFeedbackCycle = queryClient.getQueryData<AdminFeedbackCycle>([
      QUERY_KEYS.ADMIN_FEEDBACK_CYCLE,
      cycle.id,
    ]);

    if (cachedFeedbackCycle) {
      queryClient.setQueryData([QUERY_KEYS.ADMIN_FEEDBACK_CYCLE, cycle.id], cycle);
    }
  },
};

export default feedbackCycleCache;
